<template>
  <login-wrap
    id="login-unset-password"
    :text="text">
    <form>
      <qx-button
        id="reset-email"
        :title="sendEmailButtonLabel"
        :is-block="true"
        :in-progress="inProgress"
        state="active"
        :action="resetPassword" />
    </form>
    <another-account />
  </login-wrap>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import LoginWrap from '@/components/auth/LoginWrap.vue';
import anotherAccount from '@/elements/auth/anotherAccount.vue';
import qxButton from '@/elements/button.vue';

import { requestPasswordReset, signIn } from '@/api';
import EventBus from '@/elements/eventBus.js';
import { PASSWORD_CODE } from '@/utils/cons.js';
import { btoa } from '@/elements/utils.js';

export default {
  name: 'LoginUnsetPassword',
  components: {
    anotherAccount,
    qxButton,
    LoginWrap,
  },
  data() {
    return {
      inProgress: false,
      isSent: false,
      text:
        this.$gettext(
          "You haven't set your password yet. Click the button below to request a link for setting your password"
        ) + '.',
      sendEmailButtonLabel: this.$gettext('Send the link'),
    };
  },
  computed: {
    ...mapState({
      userEmail: (state) => state.auth.userEmail,
    }),
  },
  methods: {
    ...mapMutations({
      setMfaCode: 'auth/setMfaCode',
    }),
    async resetPassword() {
      if (this.inProgress) {
        return;
      }
      this.inProgress = true;
      try {
        await requestPasswordReset([this.userEmail]);
        this.$notify({
          text: this.$gettext('Check your email for the link to set your password.'),
          type: 'notice',
        });
        const tempToken = btoa(`${this.userEmail.toLowerCase()}:`);
        await signIn(tempToken);
        this.setMfaCode(PASSWORD_CODE);
      } catch (error) {
        if (error.response) {
          EventBus.$emit('handle-error', { response: error.response });
        }
      } finally {
        this.inProgress = false;
      }
    },
  },
};
</script>
